export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_DOCUMENTS = 'ERROR_DOCUMENTS';
